module.exports = __webpack_public_path__ + "static/img/bf.fb8f71d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/bf.jpg
// module id = k9sg
// module chunks = 5